<template>
  <div class="page-contain">
    <breadcrumb :breadStaticData="breadStaticData" :linkData="linkData" :thirdStaticData="thirdStaticData"></breadcrumb>
    <div class="page-table">
      <div class="title-tab">
        <div class="title-tab-btns">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="add">新增</el-button>
        </div>
      </div>
      <el-table 
        ref="table" 
        class="my-table"
        size="small" 
        :data="listData" 
        highlight-current-row 
        border
        v-loading="loading"  
        :element-loading-text="loadtext" 
        :height="tableHeight"
        v-bind="$attrs"
        v-on="$listeners"
      >
        <el-table-column align="center" type="index" width="70" label="序号">
          <template slot-scope="scope">
            <span>{{
              pageparm
                ? (pageparm.page - 1) * pageparm.limit +
                  scope.$index +
                  1
                : scope.$index + 1
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(headData, index) in tableHead"
          :key="index"
          :prop="headData.prop"
          :label="headData.label"
          :width="headData.width"
          :align="headData.align || 'center'"
          :header-align="headData.headerAlign || 'center'"
          :min-width="headData.minWidth"
          :show-overflow-tooltip="false"
        >
          <template slot-scope="scope">
            {{ scope.row[headData.prop] || '' }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="view(scope.row, scope.$index)">查看</el-button>
            <el-button v-if="scope.row.payStatus == '01'" size="small" type="text" @click="edit(scope.row, scope.$index)">修改</el-button>
            <el-button v-if="scope.row.payStatus == '01'" size="small" type="text" @click="del(scope.row, scope.$index)">删除</el-button>
            <el-button v-if="scope.row.payStatus == '01'" size="small" type="text" @click="pay(scope.row, scope.$index)">继续支付</el-button>
            <el-button v-if="scope.row.payStatus == '02'" size="small" type="text" @click="lookSteam(scope.row, scope.$index)">物流信息</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination v-bind:child-msg="pageparm" @refreshTable="refreshTable"></pagination>
    </div>
    <free-edit ref="editForm" @getData="getData"></free-edit>
    <steam ref="steam"></steam>
    <pay ref="pay" @getpay="getpay"></pay>
  </div>
</template>
<script>
  import pagination from '@/components/pagination.vue'
  import breadcrumb from '@/components/breadcrumb.vue'
  import freeEdit from './freeEdit.vue'
  import steam from '../common/steam.vue'
  import pay from '@/views/common/pay.vue'
  import { request, utils, CONSTPARAMS, baseValidate } from '@/utils/baseUtils'
  export default {
    name: 'freeList',
    components: {
      pagination,
      breadcrumb,
      freeEdit,
      steam,
      pay
    },
    data() {
      let title = '电子合格证和蓝牙打印机'
      return {
        allSelData: [],
        breadStaticData:['承诺达标合格证管理', title],
        searchForm: {
          page: CONSTPARAMS.page,
          limit: CONSTPARAMS.limit,
          bodyId: utils.getBodyId()
        },
        //订单号、产品名称、申请数量（单位）、订单金额、申请时间、支付时间、物流信息、状态、操作（修改、查看、删除、物流信息、继续支付）
        urlName: 'psfindlabelorder',
        tableHead: [{
          prop: 'electronicLabelOrderCode',
          label: '订单号',
          width: 130
        },{
          prop: 'dictName',
          label: '产品名称'
        },{
          prop: 'buyNum',
          label: '申请数量',
          width: 100
        },{
          prop: 'orderMoney',
          label: '订单金额',
          width: 100
        },{
          prop: 'createOrderTime',
          label: '申请时间',
          width: 150
        },{
          prop: 'payTime',
          label: '支付时间',
          width: 150
        },{
          prop: 'logisticCompany',
          label: '物流信息'
        },{
          prop: 'payStatusName',
          label: '支付状态',
          width: 100
        },{
          prop: 'shipmentStatusName',
          label: '发货状态',
          width: 100
        }],
        initForm: {
          bodyId: utils.getBodyId(),
          bodyName: utils.getBodyName(),
          address: '',
          phoneNum: '',
          consignee: '',
          expressFee: 10,
          allPrice: 0,
          freeNum: 0,
          orderSource: '01'
        },
        loadtext: '加载中',
        pageName: '电子合格证标签',
        tableName: `${title}列表`,
        linkData:[],
        thirdStaticData:[],
        loading: false,
        tableHeight: null,
        listData: [],
        pageparm: {
          page: CONSTPARAMS.page,
          limit: CONSTPARAMS.limit,
          total: 0
        },
      }
    },
    created() {
      this.getData()
    },
    mounted(){
      this.getTopHeight()
      // this.getautoComNum()
    },
    methods: {
      getpay(flag){
        this.getData()
      },
      pay(data){
        this.$refs.pay.initData(data.electronicLabelOrderId, data.orderMoney, data.electronicLabelOrderCode)
      },
      closemydialog(){
        this.$refs.mydialog.closeModel()
      },
      lookSteam(data){
        this.$refs.steam.initData(data)
      },
      async add(){
        // let id = await utils.getNewId(),
        let obj = {
          ...this.initForm,
          // electronicLabelOrderId: id
        }
        this.$refs.editForm.initData(`新增${this.pageName}`, 'add', obj)
      },
      view(data, index){
        this.getInfo('look', data, index)
      },
      edit(data, index){
        this.getInfo('edit', data, index)
      },
      getInfo(type, data, index){
        let _this = this
        request.psfindorderdetail({
          electronicLabelOrderId: data.electronicLabelOrderId
        }).then(res => {
          if(res.code == 200){
            let result = res.data
            if(!result){
              _this.message('此条数据信息获取为空！', "error")
              return
            }
            result = {
              ...result
            }
            delete result.createTime
            this.$refs.editForm.initData(`${type == 'edit' ? '修改' : '查看'}${this.pageName}`, type, result)
          } else {
            _this.message(res.msg || '', "error")
          }
        }).catch(e => {
          console.log(e)
        })
      },
      del(data, index){
        let _this = this
        _this.$confirm(`确认要删除订单号为${data.electronicLabelOrderCode || ''}这条记录吗？`, "提示", {
          cancelButtonText: "取消",
          confirmButtonText: "确定",
          type: "warning",
        })
        .then(() => {
          request.psdeleteLabelOrder({
            electronicLabelOrderId: data.electronicLabelOrderId,
            electronicLabelOrderCode: data.electronicLabelOrderCode
          }).then(res => {
            if(res.code == 200){
              _this.getData()
              _this.message('删除成功！', "success");
            }else{
              _this.message(res.msg || '', "error");
            }
          }).catch(e => {
            console.log(e)
          })
        }).catch(() => {})
      },
      getTopHeight(){
        let getTopHeight = utils.getTopHeight()
        this.tableHeight = `calc(100% - ${getTopHeight}px)`
      },
      refreshTable(parm) {
        this.searchForm.page = parm.page
        this.searchForm.limit = parm.limit
        this.getData()
      },
      getData(flag = false){
        let _this = this
        if(flag){
          this.searchForm.page = CONSTPARAMS.page
          this.searchForm.limit = CONSTPARAMS.limit
        }
        _this.loading = true
        request[_this.urlName](_this.searchForm).then(res => {
          _this.loading = false
          if(res.code == 200){
            let lists = res.data.list || [],
              obj = {
                '01': '未支付',
                '02': '已支付',
                '03': '已关闭',
                '05': '已退款',
              },
              obj2 = {
                '01': '未发货',
                '02': '已发货',
                '03': '已收件'
              }
            lists = lists.map(item => {
              return {
                ...item,
                payStatusName: obj[item.payStatus],
                shipmentStatusName: obj2[item.shipmentStatus],
              }
            })
            _this.listData = lists
            _this.pageparm.page = _this.searchForm.page
            _this.pageparm.total = res.data.total || 0
            _this.$nextTick(() => {
              _this.$refs.table && _this.$refs.table.doLayout()
            })
          }else{
            _this.message(res.msg || '', "error")
          }
        }).catch(e => {
          console.log(e)
          _this.loading = false
        })
      },

    },
  }
</script>
<style lang="scss" scoped>
</style>